/**
 * Display "unit of product sold" for tables and detail views: quantity from the
 * row's `unitOfProductSold` plus the unit from product master `soldUnit` when present.
 *
 * @param {Record<string, unknown>} row - API list/detail row (may include `masterProduct`, `unitOfProductSold`, `unitOfProductSoldUnit`)
 * @returns {string}
 */
export function formatUnitOfProductSoldCell(row) {
  const masterUnit =
    row?.masterProduct?.soldUnit != null
      ? String(row.masterProduct.soldUnit).trim()
      : "";
  const u = row?.unitOfProductSold;

  if (u && typeof u === "object") {
    const qty = u.value !== undefined && u.value !== null ? u.value : "";
    const unitLabel = masterUnit || (u.unit != null ? String(u.unit).trim() : "");
    const combined = `${qty} ${unitLabel}`.trim();
    return combined || "N/A";
  }

  if (u === null || u === undefined || u === "") return "N/A";

  const legacyUnit = masterUnit || String(row?.unitOfProductSoldUnit || "").trim();
  const combined = [u, legacyUnit].filter(Boolean).join(" ").trim();
  return combined || String(u);
}
